import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeContainerComponent, CeEmptyStateImports } from '@kempower-nx-workspace/shared/kp-design-system';
import { Auth0Service } from '../../data-access/auth0-service/auth0.service';

@Component({
    selector: 'ce-auth0-login',
    imports: [CommonModule, CeContainerComponent, CeEmptyStateImports],
    providers: [Auth0Service],
    templateUrl: './authentication-login.component.html'
})
export class AuthenticationLoginComponent {
    readonly #auth0Service = inject(Auth0Service);

    constructor() {
        this.#auth0Service.login();
    }
}
